export type FaqItem = {
  question: string;
  answer: string;
};

export type FaqSection = {
  id: string;
  title: string;
  items: FaqItem[];
};

export const FAQ_SECTIONS: FaqSection[] = [
  {
    id: "getting-started",
    title: "Getting started",
    items: [
      {
        question: "Is Scoopulator actually free to use?",
        answer:
          "Yes, Scoopulator is completely free. And no ads (ever). At some point in the future, there may be a paid upgrade with additional features, but the core experience will always remain free.",
      },
      {
        question: "Do I need an account?",
        answer:
          "No account is required to use the calculator. However, creating a free account lets you create custom ingredients, save your recipes, and access them from any device.",
      },
    ],
  },
  {
    id: "using-the-calculator",
    title: "Using the calculator",
    items: [
      {
        question: "Why does the calculator measure everything in grams?",
        answer:
          "Grams are the standard unit in professional ice cream making because they are precise and consistent. Volumetric measurements like cups or tablespoons can vary wildly depending on how ingredients are packed or scooped. This is especially true for stabilizers, which are used in very small quantities. It's recommended to use a kitchen scale which measures to 0.1g for best results.",
      },
      {
        question: "What are the target profiles?",
        answer:
          "Target profiles give you suggested ranges for your recipe's composition, such as sweetness, fat, and total solids. Choose your desired texture separately with the Firmness setting, and use the Serving setting to choose the temperature at which the calculator estimates firmness. These ranges are useful guidelines, not hard rules. Use them as a starting point and adjust based on your results.",
      },
      {
        question: "How do I target the firmness I want?",
        answer:
          "Choose a Firmness setting, such as Standard scoop or Soft scoop, then choose the Serving setting that matches how you plan to serve your ice cream. The calculator estimates how firm your recipe will be at that temperature and compares it with your chosen firmness range. Adjust your ingredients and amounts to bring the estimate into range while keeping an eye on sweetness and total solids. Changing the Serving setting changes the estimated firmness, but your firmness target stays the same.",
      },
      {
        question: "What does the firmness percentage mean?",
        answer:
          "Firmness is based on the percentage of your recipe's original water that is frozen at the selected serving temperature, with an adjustment for ingredients such as chocolate and nuts that make it feel firmer. A higher percentage means a firmer texture. It's an estimate to help you compare and adjust recipes; use your finished ice cream to judge the texture you prefer.",
      },
      {
        question: "Will Scoopulator work for the Ninja Creami?",
        answer:
          "Yes! All ice cream machines will benefit from using an ice cream calculator. Recipes which are balanced for a traditional churner will generally work well in the Ninja Creami, with no need for a respin. In a future release, Scoopulator will extra support for the Ninja Creami.",
      },
    ],
  },
  {
    id: "common-issues",
    title: "Common issues and troubleshooting",
    items: [
      {
        question: "Why didn't my ice cream freeze?",
        answer:
          "If your ice cream came out liquid or barely set, check both your recipe and your machine's preparation instructions. In the calculator, choose the Serving setting that matches how you plan to serve it and check whether the estimated firmness is below your target range. Too much sugar or alcohol can keep a recipe too soft. For a traditional churner, chill the base in the refrigerator before churning and prepare the machine as directed. For a Ninja Creami, freeze the base according to the machine's instructions before processing.",
      },
      {
        question: "Do I need stabilizers?",
        answer:
          "Stabilizers are optional, but they help control ice crystal growth and improve texture. Stabilizers like xantan gum and guar gum can be commonly found in grocery stores.",
      },
      {
        question: "Why is my ice cream 'slimy', 'chewy', or 'gummy'?",
        answer:
          "A slimy or gummy texture is often caused by overuse of stabilizers. If you are using gums, make sure to measure them accurately (using a precise scale), as even a small excess can lead to this issue.",
      },
    ],
  },
];
